import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { IAppState } from '../../../../../state/reducers';
import { IProps, IStateProps } from './interfaces';
import { VAULT_MEDIA_TYPE } from '../../../../../constants/vault';
import { IconType } from '../../../../../constants';
import ExchangeVideoPlayer from '../VideoPlayer/component';
import ExchangeEmptyMedia from '../EmptyMedia/component';
import ExchangeImageContent from '../ImageContent/component';

class ExchangeMediaContent extends React.Component<IProps> {
  renderContent = () => {
    const {
      mediaInformation: { type, source },
    } = this.props;
    const { video, clip, liveVideo } = VAULT_MEDIA_TYPE;

    return type === video || type === clip || type === liveVideo ? (
      <ExchangeVideoPlayer data-tip="Video" /> // asset which contains valid video url
    ) : (
      <ExchangeImageContent data-tip="Preview" /> // asset which contains preview/thumbnail image
    );
  };

  render() {
    const {
      mediaInformation: { type, source },
      assetType,
      assetId,
      assetDetailsId,
    } = this.props;

    // Non-media assets (e.g. hockey xml uploads) have nothing to play or preview, so the
    // media area is dropped rather than filled with a placeholder.
    //
    // Activate sets assetId straight away while rawAssetDetails keeps the previously
    // selected asset until the fetch resolves, so assetType cannot be trusted until the
    // details it came from belong to the selected asset. Until then this renders nothing
    // rather than the previous asset's player or a placeholder that is about to change.
    const mediaAssetTypes: string[] = [IconType.VIDEO, IconType.LIVE_VIDEO, IconType.CLIP, IconType.IMAGE];
    const detailsMatchSelection = assetDetailsId === assetId;
    if (assetId && (!detailsMatchSelection || !mediaAssetTypes.includes(assetType))) return null;

    return !type || !source
      ? (
        <ExchangeEmptyMedia data-tip="Video Unavailable" />
      ) // unknown asset type or media source unavailable
      : this.renderContent();
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  mediaInformation: state.exchange.activeAsset.mediaInformation,
  assetType: state.exchange.activeAsset.rawAssetDetails?.type ?? null,
  assetId: state.exchange.activeAsset.assetId,
  // activeAsset.assetId is the asset's _id (see selectActiveAssetDetails), so these are
  // comparable and tell us whether the loaded details are the selected asset's.
  assetDetailsId: state.exchange.activeAsset.rawAssetDetails?._id ?? null,
});

export default connect(
  mapStateToProps,
)(ExchangeMediaContent);
